<template>
	<div class="deal-box" :data-id="deal.deal_id">
		<router-link :to="{ name: 'Deal', params: { dealId: deal.slug } }">

			<!----------------------------------------------------
				Header - Flags & Price
			------------------------------------------------------->
			<div class="top">
				<div>
					<div v-if="onSale">
						<span class="badge badge-green" v-if="amountOff >= 100">${{ amountOff }} off</span>
						<span class="badge badge-green" v-else-if="percentOff > 0">{{ percentOff }}% off</span>
						<span class="badge badge-green" v-else>on sale</span>
					</div>
					<!-- <span class="tago">3 hours ago</span> -->
					<!-- <span class="badge badge-blue">sponsored</span> -->
				</div>
				<div>
					<div class="price">
						{{ price }}
					</div>
				</div>
			</div>


			<!----------------------------------------------------
				Deal Image & Title
			------------------------------------------------------->
			<div class="flexwrap">
				<div class="img">
					<div>
						<img :src="image" alt="">
					</div>
				</div>
				<div class="title">
					{{ deal.name }}
				</div>
			</div>

		</router-link>
		
		<!----------------------------------------------------
			Base - Brand & Buy Button
		------------------------------------------------------->
		<div class="btm">
			<div class="hint--top" :aria-label="store">
				<div class="store">
					{{ store }}
				</div>
			</div>
			<div>
				<a :href="deal.urls.affiliate" target="_blank">
					<i class="fas fa-shopping-cart"></i> &nbsp;
					Go To Deal
				</a>
			</div>
		</div>


	</div>
</template>

<script>
export default {
	name: "Deal",
	props: ['deal'],
	data: function() {
		return {}
	},
	computed: {

		price() {

			//
			const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', });

			try {

				if( this.onSale )
					return formatter.format(this.deal.prices.sale);

				return formatter.format(this.deal.prices.price);
				
			}catch(e) {
				return formatter.format(0);
			}

		},

		image() {
			try {
			
				//if we have an original size, use it
				if( this.deal.images.original && this.deal.images.original.length > 0 )
					return this.deal.images.original;
					// return ["/assets/imgs?asset=", this.deal.images.original].join("");

				//use the thumb
				return this.deal.images.thumb;
				// return ["/assets/imgs?asset=", this.deal.images.thumb].join("");

			}catch(e) {
				return "";
			}
		},

		store() {
			try {
				return ( typeof this.deal.attributes.store === 'string' ) ? this.deal.attributes.store : this.deal.attributes.store[0];

			}catch(e) {
				return "";
			}
		},

		onSale() {
			try {
				return this.amountOff > 0;
			}catch(e) {
				return false;
			}
		},
		amountOff() {
			try {
				return Math.floor(this.deal.savings.amount);
			}catch(e) {
				return 0;
			}
		},
		percentOff() {
			try {
				return Math.floor(this.deal.savings.percent);
			}catch(e) {
				return 0;
			}
		}

	},
	methods: {}
};
</script>

<style lang="scss">
.deal-box {
	position: relative;
	border-style: solid;
	border-width: 1px;
	border-color: rgb(147, 146, 146);
	background-color: rgb(255, 255, 255);
	box-shadow: 0px 0px 6.88px 1.12px rgba(1, 1, 1, 0.16);
	margin-bottom: 25px;
	padding-bottom: 40px;
	min-height: 200px;
	max-width: 350px;

	>a {
		display: block;
		color: #3b3f47;
		text-decoration: none;
	}

	//
	.top {
		position: relative;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-top: 10px;

		>* {
			&:first-child {
				padding: 0 10px;
			}
		}

		.tago {
			padding-left: 5px;
		}

		.price {
			// margin-right: -10px;
			padding: 7px 15px;
			background-color: #d41b00;
			color: #fff;
			font-size: 15px;
			line-height: 15px;
			// font-weight: bold;
		}
	}

	.flexwrap {
		position: relative;
		display: flex;
		padding: 15px;
	}

	//
	.img {
		position: relative;
		padding: 20px;
		width: 100px;
		height: 100px;
		// overflow: hidden;
		text-align: center;
		flex-shrink: 0;
		border: #efefef 1px solid;

		>div {
			// background: url("../../public/images/photo-placeholder.jpeg") no-repeat center;
			// background-size: cover;
		}

		img {
			display: block;
			background-color: #fff;
			max-width: 100%;
			max-height: 80px;
			height: auto;
			margin: 0 auto;
		}
	}

	//
	.title {
		flex-grow: 1;
		padding: 0 20px 15px;
		font-weight: bold;
		text-overflow: ellipsis;
		overflow: hidden;
		line-height: 21px;
	}

	//
	.btm {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 40px;
		display: flex;
		justify-content: space-between;
		background-color: #e5e0bf;
		line-height: 40px;
		color: #3b3f47;
		white-space: nowrap;
		font-size: 13px;

		>* {
			&:first-child {
				padding: 0 12px;
				max-width: 50%;
			}
		}

		.store {
			text-transform: capitalize;
			text-overflow: ellipsis;
			overflow: hidden;

			[class*="hint--"][aria-label]:after {
				text-transform: capitalize;
			}
		}

		a {
			display: block;
			padding: 0 12px;
			background-color: #cdc7a2;
			color: #3b3f47;
			text-decoration: none;

			@media (hover) {
				&:hover {
					background-color: #d2c15c;
				}
			}
		}
	}

	//
	@media ( min-width: 480px ) {
		.flexwrap {
			display: block;
			padding: 0;
		}
		.img {
			border: none;
			width: auto;
			height: auto;
		}
	}

	//
	@media ( min-width: 768px ) {
	}

	//
	@media ( min-width: 1080px ) {
	}
}
</style>